import {useTranslation} from "@i18n/client";
import React from "react";
import {LazyImg} from "src/components/_common/LazyImg";
import {Bio, defaultImage} from "src/constants/BiosConstants";
import {useV5ImgSrc} from "src/useV5ImgSrc";

type Props = {
  person: Bio;
  index: number;
  toggleActiveIndex: (num: number) => () => void;
};

// eslint-disable-next-line react/display-name
const BioCard = React.forwardRef<HTMLDivElement, Props>(
  ({index, person, toggleActiveIndex}, ref) => {
    const i18n = useTranslation();

    const firstImage = person.images[0] || defaultImage;

    return (
      <div
        key={person.name}
        ref={ref}
        role="button"
        tabIndex={0}
        style={{"--br": 0.5}}
        className="df fdc mb10 cp w58 w48-sm w100p-xs focus-bsDarkBlue3 mr2 mb2 m0-xs"
        aria-label={i18n.t("Open profile for {{name}}", {name: person.name})}
        onKeyDown={e => e.key === "Enter" && toggleActiveIndex(index)()}
        onClick={toggleActiveIndex(index)}
      >
        <LazyImg
          className="br2 mb3 h72 h40-md obfc"
          src={useV5ImgSrc(`/${firstImage.src || "default"}`)}
          aria-label={firstImage.alt}
          alt={firstImage.alt}
        />
        <span className="font-mr ttu mb1 fs12 lh15" style={{letterSpacing: 0.7}}>
          {person.title}
        </span>
        <span className="font-cm fs20" style={{letterSpacing: -0.3}}>
          {person.name}
        </span>
      </div>
    );
  },
);

export default BioCard;
